import { Context } from './Context';
import { useStreamWorkflowCheck } from './useStreamWorkflowCheck';
export function WorkflowCheckProvider(props) {
    const { type, documentId, children } = props;
    const { state, error, startWorkflowCheck, approvalResult, signatoryResult, approvalWorkflows, signatoryWorkflows } = useStreamWorkflowCheck(documentId, type);
    const value = {
        type,
        state,
        error,
        startCheck: startWorkflowCheck,
        approvalResult,
        signatoryResult,
        approvalWorkflows,
        signatoryWorkflows,
    };
    return <Context.Provider value={value}>{children}</Context.Provider>;
}
